<div *ngIf="appointment.customer" class="mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-3 sm:gap-x-4">
  
  <div *ngFor="let address of appointment.customer.addresses" (click)="addressClicked(address)" [ngClass]="{'border-accent ring-2 ring-accent': ( appointment.address && appointment.address.id === address.id )}"  class="relative hover:border-accent hover:ring-2 hover:ring-accent flex cursor-pointer rounded-lg border bg-white p-4 shadow-sm focus:outline-none">
    <input type="radio" name="project-type" value="Newsletter" class="sr-only">
    <span class="flex flex-1">
      <span class="flex flex-col">
        <span class="block text-sm font-bold text-gray-900">{{ address.line1 }}</span>
        <span class="mt-1 flex items-center text-xs text-gray-500">{{ address | addressFormatter }}</span>
        <span class="mt-6 text-xs font-medium text-gray-900">{{ address.appointmentsCount }} appointment{{(address.appointmentsCount === 1) ? '' : 's'}} at this address</span>
      </span>
    </span>
   
    <svg [ngClass]="{'invisible': (!appointment.address || appointment.address.id !== address.id )}" class="h-5 w-5 text-accent" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd" />
    </svg>
   
    <span class="pointer-events-none absolute -inset-px rounded-lg border-2" aria-hidden="true"></span>
    <span class="absolute bottom-2 right-2 text-xs" (click)="addressEditClicked($event, address)">EDIT</span>
  </div>
  <div  (click)="newAddressClicked()"   class="relative hover:border-accent hover:ring-2 hover:ring-accent flex cursor-pointer rounded-lg border bg-white p-4 shadow-sm focus:outline-none">
    <input type="radio" name="project-type" value="Newsletter" class="sr-only">
    <span class="flex flex-1">
      <span class="flex flex-col justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
        </svg>
        
        <span class="block text-sm font-bold text-gray-900">Add address</span>
        <span class="mt-1 flex items-center text-xs text-gray-500"></span>
        <span class="mt-6 text-xs font-medium text-gray-900"></span>
      </span>
    </span>
   
    
   
    <span class="pointer-events-none absolute -inset-px rounded-lg border-2" aria-hidden="true"></span>
  </div>
  
  
</div>